import React, { Fragment } from 'react'
import {
  DesignTokens,
  Frame,
  SpacerVertical,
} from '@klarna/bubble-ui'
import PaymentMethod from '../PaymentMethod/PaymentMethod'
import PaymentMethodDetails from '../PaymentMethodDetails/PaymentMethodDetails'
import isAnyValueEmpty from '../../utilities/isAnyValueEmpty'

type PaymentMethodProps = {
  badge: string
  purchaseAmount: string
  backgroundColorKey: string
  frequencyTitle?: string
  installmentAmount?: string
}

type PaymentMethodDetailsProps = {
  installmentsTotal: string
  totalTranslation: string
  apr: string
  aprParagraph: string
  aprTranslation: string
  interestTranslation?: string
  interestFreeTranslation?: string
  interestAmount?: string
  downPayment?: string
  downPaymentTranslation?: string
  finalPayment?: string
  finalPaymentTranslation?: string
}

type PaymentMethodContainerProps = {
  heading?: string
  frameBackground: string
  paymentMethodProps?: PaymentMethodProps
  paymentMethodDetailsProps?: PaymentMethodDetailsProps
};

const PaymentMethodContainer: React.FC<PaymentMethodContainerProps> = ({
  frameBackground = 'colors/borders/subtle-surface',
  paymentMethodProps = null,
  paymentMethodDetailsProps = null
}) => {
  const designContext = DesignTokens.useDesignContext()
  const shouldDisplayPM = !isAnyValueEmpty(paymentMethodProps)
  return (
    <Fragment>
      { shouldDisplayPM ? (
        <Fragment>
          <Frame
            UNSAFE_style={{
              padding: 16,
              borderColor: designContext.get<DesignTokens.Color>(frameBackground).toString(),
              borderRadius: 16,
              borderWidth: 1
            }}>
            <PaymentMethod {...paymentMethodProps} />
            {paymentMethodDetailsProps ? <PaymentMethodDetails {...paymentMethodDetailsProps} /> : null}
          </Frame>
          <SpacerVertical spaceToken="space.150" />
        </Fragment>
      ) : null }

    </Fragment>
  )
}

export default PaymentMethodContainer
